import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import store from '../store';

// Sprachen importieren
import de from 'vuetify/es5/locale/de'
import en from 'vuetify/es5/locale/en'
import it from 'vuetify/es5/locale/it'
import hu from 'vuetify/es5/locale/hu'
import cs from 'vuetify/es5/locale/cs'
import sk from 'vuetify/es5/locale/sk'
import hr from 'vuetify/es5/locale/hr'
import sl from 'vuetify/es5/locale/sl'
import ro from 'vuetify/es5/locale/ro'
import bg from 'vuetify/es5/locale/bg'

Vue.use(Vuetify); 



export default new Vuetify({
  theme: {
    options: {
      customProperties: true, // <- wichtig!
    },
    themes: {
      light: {
        
      },
    },
  },
  icons: {
    iconfont: 'mdi',
  },
  lang: {
    locales: { de, en, it, hu, cs, sk, hr,sl, ro, bg },
    current: store.getters.getLanguage || 'de',
  },
  defaultAssets: {
    icons: false,
    font: false,
  },
 
});